<template>
  <div class="highcharts-light user-details-pie-chart chart-container">
    <highcharts :options="chartOptions"></highcharts>
  </div>
</template>

<script>
import _ from 'lodash';
import {Chart} from 'highcharts-vue';
import Highcharts from 'highcharts';
import addAccessibility from 'highcharts/modules/accessibility';
import noDataToDisplay from 'highcharts/modules/no-data-to-display';
addAccessibility(Highcharts);
noDataToDisplay(Highcharts);

export default {
  name: 'user-details-pie-chart',
  components: {
    highcharts: Chart
  },
  props: {
    chartSeries: {
      type: Array,
      default: () => []
    },
    clickCallback: {
      type: Function,
      default: _.noop
    }
  },
  computed: {
    chartOptions: function() {
      let self = this;
      return {
        chart: {
          styledMode: true,
          type: 'pie',
          width: 170,
          height: 270,
          spacingTop: -80
        },
        title: {
          text: undefined
        },
        lang: {
          noData: 'No Data To Display'
        },
        noData: {
          style: {
            fontSize: '14px',
            fontWeight: '400',
            color: '#253035',
            fontFamily: '"Forma DJR UI", Arial, sans-serif'
          }
        },
        legend: {
          layout: 'vertical',
          floating: true,
          y: 10,
          itemMarginBottom: 6,
          symbolHeight: 15,
          useHTML: true,
          itemStyle: {
            fontSize: '14px',
            color: '#253035',
            fontFamily: '"Forma DJR UI", Arial, sans-serif'
          },
          labelFormatter: function() {
            // todo: this case-by-case strategy for alignment really sucks, but I'm not sure if highcharts lets us customize the legend as a whole rather than each individual line,
            //       so the desired table-style layout may not be accomplishable in a reasonable way.
            //       Should look into modifying the CSS of the highcharts-generated legend HTML; may need to use !important styles to override
            let lcName = this.name.toLowerCase(),
                margin = 10;
            if (lcName === 'fair' || lcName === 'bad') {
              margin = 20;
            } else if (lcName === 'wifi') {
              margin = 20;
            } else if (lcName === 'cellular') {
              margin = 15;
            } else if (lcName === 'vpn') {
              margin = 35;
            }
            return '<div style="position: relative; bottom: 1px;">' +
                     '<span style="margin-right: ' + margin + 'px; font-weight: normal">' + this.name + '</span><span style="font-weight: bold">' + Math.round(this.percentage) + '%</span>' +
                   '</div>';
          }
        },
        tooltip: {
          style: {
            color: '#253035',
            fontFamily: '"Forma DJR UI", Arial, sans-serif'
          },
          useHTML: true,
          formatter: function() {
            return `<svg width="10" height="10"><circle cx="5" cy="5" r="4"/></svg> ` + this.point.name + ': <b>' + parseFloat(this.percentage.toFixed(2)) + '%</b>' +
                   '<br>' +
                   '<span style="position:relative;left:10px;">(' + this.y + ' total)</span>';
          }
        },
        plotOptions: {
          series: {
            point: {
              events: {
                click: self.clickCallback
              }
            }
          },
          pie: {
            borderRadius: 0,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        credits: {
          enabled: false
        },
        series: self.chartSeries
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-details-pie-chart {}
</style>

<style lang="scss">
.user-details-pie-chart.chart-container {
  .highcharts-container {
    width: min-content;
    margin: 0 auto;
    .highcharts-legend-item span {
      font-size: 14px;
    }
  }
}
</style>
